import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { MAX_SERVER_REQUESTS_ERROR } from "./OtpVerifyRegisterWithBankAccount";

export async function OTPVerifyForViewDoc(userId: string, _otpPassword: string) {
  if (userId?.length && _otpPassword?.length) {
    try {
      const body = {
        memberID: userId,
        linkID: sessionStorage.getItem("requestID"),
        otpPassword: _otpPassword,
      };
      const path = environment.BASE_URL + "MemberLogin/OTPVerifyForViewDoc";
      const res: AxiosResponse<any> = await axios.post(path, body);
      if (axiosUtil.isSuccess(res) && res?.data?.tokenNum?.length) {
        const token = res.data.tokenNum;
        return token;
      }

      if (res?.data?.errorCode === 36) return MAX_SERVER_REQUESTS_ERROR;
      return "";
    } catch (err) {
      console.log(err);
    }
  }
  return "";
}
